import Title from './title'
import RoundBox from './round-box'
import AboutBlock from './block-about'

export default function StudioPerformance({ performance }) {
  const t = useI18n()

  return (
    <AboutBlock borderbVisible={ false }>
      <div className='translate-y-[-32px] translate-x-[-32px] w-[100vw] md:hidden'>
        <C.Image
          className='w-full aspect-[5/3] drop-shadow-md'
          src={ cdn('next/join-us/performance-1.jpg') }
        />
      </div>

      <Title>{ t('page:joinUs.studioPerformance.title') }</Title>
      <div className='flex flex-col md:space-x-8 md:flex-row justify-center mt-3'>
        <div className='grid  grid-cols-2 gap-4 mb-4 md:mb-0 z-[1]'>
          <Item t={ t } itemKey='store' value={ performance.studioCount }/>
          <Item t={ t } itemKey='stylist' value={ performance.stylistCount }/>
          <Item t={ t } itemKey='booking' value={ performance.bookingCount }/>
          <Item t={ t } itemKey='newCustomer' value={ performance.newCustomerCount }/>
        </div>

        <div className='w-full hidden md:flex'>
          <C.Image
            className='w-full aspect-[5/2] drop-shadow-md'
            src={ cdn('next/join-us/performance-6.png') }
          />
        </div>
        <div className='translate-y-[-32px] translate-x-[-32px] w-[100vw] md:hidden'>
          <C.Image
            className='w-full aspect-[5/3] drop-shadow-md'
            src={ cdn('next/join-us/performance-5.jpg') }
          />
        </div>
      </div>
    </AboutBlock>
  )
}

const Item = ({ t, itemKey, value }) => {
  const title = t(`page:joinUs.studioPerformance.${itemKey}.title`)
  const unit = t(`page:joinUs.studioPerformance.${itemKey}.unit`)

  return <RoundBox className='aspect-[4/3]'>
    <div className='flex flex-col space-y-1 items-center text-lg md:text-base tracking-widest px-4 py-2 md:px-10 md:py-4 whitespace-pre h-full justify-center'>
      <div>{ title }</div>
      <div>
        <span className='font-semibold text-base'>{value.format()}</span> {unit}
      </div>
    </div>
  </RoundBox>
}
